<template>
  <k-page class="page-settings">
    <the-tax-settings />
  </k-page>
</template>

<script>
/**
 * Component: page-settings - Страница настроек
*
* @version 1.0.0
*/


// Components
import TheTaxSettings from '@/components/TheTaxSettings.vue';
import KPage from '@/components/KPage.vue';


export default {
  name: 'page-settings',

  components: {
    KPage,
    TheTaxSettings,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-settings {
  $this: &;
}
</style>
